<template>
    <div class="itemsListing">
        <div class="d-flex align-center pr-3 mt-4">
            <span class="ml-6 text-h6">Items</span>
            <v-spacer></v-spacer>
            <v-text-field label="Search items" v-model="searchItem" style="max-width: 450px;"></v-text-field>
          </div>
          <v-btn rounded class="elevation-0 white--text save-btn btn right-btn" height="35px" @click="editItem= {}; createItem = true">Add Item</v-btn>  
          <v-data-table :headers="headers" no-data-text="No record found" :items="itemListing" :items-per-page="10" class="pa-2" :loading="loadData"
            :search="searchItem">
            <template v-slot:item.is_active="{ item }">
                <span>{{item.is_active ? 'Active': 'Inactive'}}</span>
            </template>
            <template v-slot:item.item_category="{ item }">
                <span class="capitalise">{{item.item_category}}</span>
            </template>
            <template v-slot:item.actions="{ item }">
                <!-- <span class="mdi mdi-download" color="#1ca088" title="Download item" style="cursor: pointer;"
                @click="downloadFile(item.template_file)"></span> -->
                <span class="mdi mdi-pencil" @click="editItems(item)" title="Edit"></span>
                <span class="mdi mdi-delete" :disabled="true" color="red" title="Delete" style="cursor: pointer;"
                @click.stop="deletePopup = true; deleteItem = item"></span>
                <v-btn small rounded class="elevation-0 btn basic-button" :class="item.is_active ? 'cancel-btn' : 'save-btn'" @click="disableItems(item)">{{item.is_active ? 'Disable' : 'Enable'}}</v-btn>
            </template>
        </v-data-table>
        <v-dialog v-model="deletePopup" persistent max-width="500px" transition="dialog-transition">
            <v-card>
                <v-card-title class="d-flex justify-space-between">
                    <span>Delete Item</span>
                    <v-icon style="cursor: pointer;" @click="deletePopup = false;" title="close">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="align-left">
                    Are you sure you want to delete this Item?
                </v-card-text>
                <v-card-actions class="btm-padding">
                    <v-spacer></v-spacer>
                    <v-btn color="success" small rounded class="elevation-0 save-btn btn" @click.stop="deleteItems(deleteItem)">Delete</v-btn>
                    <v-btn color="red" small rounded class="white--text elevation-0 cancel-btn btn"
                        @click="deletePopup = false;">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="createItem" class="" width="500px" persistent>
            <v-card width="500px" class="pa-5">
                <div class="d-flex justify-space-between">
                    <h4>{{editItem && editItem._id ? 'Edit Item' : 'Add Item'}}</h4>
                    <span @click="resetModal()" style="cursor: pointer;" title="close"><v-icon>mdi-close</v-icon></span>
                </div>
                <div class="form-container">
                    <v-text-field v-model="itemName" hide-details="auto" label="Item name"></v-text-field>
                    <v-autocomplete
                        :items="disciplineList"
                        item-text="name"
                        item-value="_id"
                        :menu-props="{ bottom: true, offsetY: true }"
                        v-model="selectedDescipline"
                        label="Select a Discipline"
                        :clearable="true"
                    ></v-autocomplete>
                    <v-autocomplete
                        :items="categoryList"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ bottom: true, offsetY: true }"
                        v-model="selectedCategory"
                        label="Select a Category"
                        :clearable="true"
                        return-object
                        @change="checkLLM($event)"
                    ></v-autocomplete>
                    <!-- <label class="">LLM item</label> -->
                    <v-checkbox class="custom-checkbox" :disabled="disableLLM" label="LLM item" v-model="isLLM"></v-checkbox>
                    <v-file-input v-if="!isLLM" style="margin-left: -6px;" accept=".xlsx" ref="fileData" label="Drop or Click the zone to add a Data Dictionary file" v-model="files"></v-file-input>
                </div>
                <v-card-actions class="d-flex">
                    <v-spacer></v-spacer>
                    <v-btn rounded :disabled="!itemName || !selectedDescipline || !selectedCategory || validateLLM" class="elevation-0 white--text save-btn btn" height="35px" @click="uploadFile()">{{editItem && editItem._id ? 'Update' : 'Create'}}</v-btn>
                    <v-btn rounded class="elevation-0 white--text cancel-btn btn" height="35px" @click="createItem=false; resetModal();">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" color="#00bf55" height="70px" :timeout="2000" >
            <span class="mdi mdi-check-circle icon-16" color="#fff"></span>
            {{ snackbarText }}
        </v-snackbar>
        <v-snackbar v-model="snackbarWarning" color="#e56565" height="70px" :timeout="2000" >
            <span class="mdi mdi-close-circle icon-16" color="#fff"></span>
            {{ snackbarText }}
        </v-snackbar>
    </div>
</template>
  
  <script>
  export default {
    data() {
      return {
        headers: [
        { text: 'Name', value:'name', width: '200px'},  
        { text: 'Descipline', value: 'discipline', width: '120px' },
        { text: 'Category', value: 'item_category', width: '100px' },
        { text: 'Status', value:'is_active', width: '100px'},
        { text: 'Last updated ', value:'updated_at' , width: '150px'},
        { text: 'Updated by', value:'updated_by', width: '140px'},
        // { text: 'Data dictionary', value:'', width: '100px'},
        { text: 'Actions', value:'actions', align: 'center', width: '200px', sortable: false},
        ],
        searchItem: '',
        deleteItem: {},
        createItem: false,
        deletePopup: false,
        disciplineList: [],
        categoryList: [],
        itemName: '',
        files: {},
        itemListing: [],
        selectedDescipline: '',
        selectedCategory: '',
        loadData: false,
        snackbarText: '',
        snackbar: false,
        snackbarWarning: false,
        editItem: {},
        isLLM: false,
        disableLLM: false
      }
    },
    components: {
    },
    computed: {
        validateLLM() {
            return this.isLLM ? false : !this.files?.name;
        },
    },
    mounted() {
        this.getItemsList();
        this.$store.dispatch('items/getDisciplineList').then((resp) => {
            this.disciplineList = resp.data.disciplines;
        });
        this.$store.dispatch('items/getCategoryList').then((resp) => {
            resp.data.item_categories.forEach(item => {
                this.categoryList.push({id: Object.keys(item)[0], name: Object.values(item)[0]});
            });
        })
    },
    created() {
      this.envChange = localStorage.getItem('env')
    },
    methods: {
        checkLLM(item) {
            if(item && item.name === 'Bulk') {
                this.isLLM = false;
                this.disableLLM = true;
            } else {
                this.isLLM = true;
                this.disableLLM = false;
            }
        },
        getItemsList() {
            this.loadData = true;
            this.$store.dispatch('items/getItemsList').then((resp) => {
                this.itemListing = resp.data.items;
                this.loadData = false;
            })
        },
        editItems(item) {
            this.createItem = true; 
            this.editItem = item;
            this.itemName = item.name;
            this.selectedDescipline = this.getDisciplineId(item.discipline);
            this.selectedCategory= this.getCategoryId(item.item_category);
            this.isLLM = item.llm_item;
            // this.isRequired = item.line_item === 'Not Required' ? 'no' : 'yes'
        },
        uploadFile() {
            if(!this.isLLM) {
                let filesData = new FormData();
                filesData.append('file', this.files);
                this.$store.dispatch('items/uploadFile', filesData).then((res) => {
                    this.createNewItem(res.data.file, this.files.name)
                }) 
            } else {
                this.createNewItem();
            }
            
        },
        createNewItem(fileUrl, file) {
            let params = {
                    item_name: this.itemName,
                    discipline_id: this.selectedDescipline,
                    item_category_id: this.selectedCategory.id || this.selectedCategory,
                }
                if(this.isLLM) {
                    params['llm_item'] = true;
                }
                if(fileUrl) {
                    params['file'] = fileUrl;
                    params['file_name'] = file;
                }
            if(this.editItem._id) {
                params['item_id'] = this.editItem._id;
                this.$store.dispatch('items/updateItem', params).then(() => {
                    this.getItemsList();
                    this.resetModal();
                    this.snackbarText = 'Updated Successfully';
                    this.snackbar = true;
                }).catch((err) => {
                    this.snackbarText = err.response.data.message;
                    this.snackbarWarning = true;
                });
            } else {
                this.$store.dispatch('items/createItem', params).then(() => {
                    this.getItemsList();
                    this.resetModal();
                    this.snackbarText = 'Created Successfully';
                    this.snackbar = true;
                }).catch((err) => {
                    this.snackbarText = err.response.data.message;
                    this.snackbarWarning = true;
                });
            }
        },
        disableItems(item) {
            let params = {
                item_id: item._id,
                // item_name: item.name,
                // discipline_id: this.getDisciplineId(item.discipline),
                is_active: !item.is_active
            }
            this.$store.dispatch('items/disableItem', params).then(() => {
                this.getItemsList();
                this.snackbarText = 'Updated Successfully';
                this.snackbar = true;
            }).catch((err) => {
                this.snackbarText = err.response.data.message;
                this.snackbarWarning = true;
            });
        },
        getDisciplineId(disciplineName) {
            return this.disciplineList.find((item) => item.name === disciplineName)?._id
        },
        getCategoryId(categoryName) {
            return this.categoryList.find((item) => item.name.toLowerCase() === categoryName.toLowerCase())?.id
        },
        deleteItems(item) {
            let params = {
                item_id: item._id,
                // item_name: item.name,
                // discipline_id: this.getDisciplineId(item.discipline),
                is_delete: true
            }
            this.$store.dispatch('items/deleteItem', params).then(() => {
                this.getItemsList();
                this.deleteItem= {};
                this.deletePopup = false;
                this.snackbarText = 'Deleted Successfully';
                this.snackbar = true;
            }).catch((err) => {
                this.snackbarText = err.response.data.message;
                this.snackbarWarning = true;
                this.deletePopup = false;
            });
        },
        resetModal() {
            this.createItem = false;
            this.itemName = '';
            this.selectedCategory = '';
            this.selectedDescipline= '';
            this.isLLM = false;
            this.files= {};
        }
    }
  }
</script>
<style lang="scss" scoped>
.text-center {
    .mdi {
        font-size: 20px;
        padding: 0 5px;
        cursor: pointer;
    }
}
.radio-label {
    text-align: left;
    margin-top: 25px;
    margin-bottom: -10px;
}
.right-btn {
    margin-right: 10px;
    margin-left: auto;
    display: block;
    margin-bottom: 5px;
}
.align-left{
    text-align: left;
}
.btm-padding{
    padding-bottom: 15px !important;
}
.modal-btn {
    margin-bottom: 10px;
}
.basic-button {
    border: 1px solid #7f7b7b;
}
.capitalise{
    text-transform: capitalize !important;
}
label {
    text-align: left;
    width: 50% !important;
    display: inline-block;
    margin-top: 15px;
}
.form-container {
    text-align: left;
}
.custom-checkbox {
    width: 50% !important;
    display: inline-block;
    margin-top: 10px;
}
</style>